import { contrastText, validColor } from "@/lib/color";
import { mediaUrl } from "@/lib/media";

interface AvatarProps {
  name?: string;
  photo?: string;
  color?: string;
  size?: number;
  className?: string;
}

// 사진이 없으면 이름 첫 글자 원형 아바타로 대체
export default function Avatar({
  name = "",
  photo,
  color,
  size = 48,
  className = "",
}: AvatarProps) {
  const initial = (name || "?").trim().slice(0, 1);
  const bg = validColor(color) || "#17408B";
  const style = { width: size, height: size };

  if (photo) {
    return (
      <span
        className={`shrink-0 overflow-hidden rounded-full bg-background-100 ${className}`}
        style={style}
      >
        <img
          src={mediaUrl(photo)}
          alt={`${name} 프로필`}
          className="h-full w-full object-cover object-top"
        />
      </span>
    );
  }

  return (
    <span
      className={`shrink-0 flex items-center justify-center rounded-full font-heading font-bold ${className}`}
      style={{ ...style, backgroundColor: bg, color: contrastText(bg) }}
      aria-hidden="true"
    >
      {initial}
    </span>
  );
}